/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {pdf} from '@react-pdf/renderer'
import {KTCard, KTCardBody} from '../../../../../_websoft/helpers'
import {useLocation, useParams} from 'react-router-dom'
import {getKupciPregled} from '../../../../api/proizvodnja'
import notifyToast from '../../../../components/Toast/Toast'
import KupciPregledPdf from '../../../paneli/components/KupciPregledPdf/KupciPregledPdf'

const KupciPdfProcessor = () => {
    const {id} = useParams()
    const location = useLocation()
    const kupac: string = location.state?.kupac || ''

    const [loading, setLoading] = useState(true)
    const [pdfUrl, setPdfUrl] = useState<string | null>(null)

    // 🔥 GROUPED TRANSFORM (PAKET STRUCTURE)
    const transformData = (data: any) => {
        if (!data) return []

        return Object.values(data).map((outer: any) => {
            const paketi: any[] = []

            Object.entries(outer).forEach(([key, value]: any) => {
                if (key === 'shared') return

                paketi.push({
                    paket: key,
                    gabarit: value?.gabarit || '-',
                    rows:
                        value?.data?.map((row: any) => ({
                            duzina: row?.duzina || 0,
                            kvadratura: row?.kvadratura || 0,
                            status: outer?.shared?.status || '-',
                            isporucen: outer?.shared?.isporucen ? 'DA' : 'NE',
                        })) || [],
                })
            })

            return {
                brojPonude: outer?.shared?.brojPonude || '-',
                brojNaloga: outer?.shared?.brojNaloga || '-',
                stavka: outer?.shared?.stavka || '-',
                vrsta: outer?.shared?.vrsta || '-',
                statusBoja: outer?.shared?.statusBoja || '-',
                boja: outer?.shared?.boja || '-',
                isporucenBoja2: outer?.shared?.isporucenBoja2 || '-',
                krajnjiKupac: outer?.shared?.krajnjiKupac || outer?.shared?.kupac || '-',
                datum: outer?.shared?.datum || outer?.shared?.statusProDatum || '-',
                ukupno: outer?.shared?.totalKvadratura || 0,
                paketi,
            }
        })
    }

    useEffect(() => {
        if (!id) return

        setLoading(true)

        getKupciPregled(id)
            .then(async (response) => {
                const structuredData = transformData(response)

                console.log('PDF DATA:', structuredData)

                const blob = await pdf(
                    <KupciPregledPdf pregledData={structuredData} kupac={kupac} />
                ).toBlob()

                const url = URL.createObjectURL(blob)
                setPdfUrl(url)
            })
            .catch((error) => {
                notifyToast(false, error?.response?.data?.message ?? error)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [id])

    return (
        <KTCard>
            <KTCardBody>

                {/* 🔵 Loading */}
                {loading && (
                    <div className='text-center m-10'>
                        <div className='spinner-border text-primary mb-3'></div>
                        <h5>Učitavanje i generisanje PDF-a...</h5>
                    </div>
                )}

                {/* 🟢 Ready */}
                {!loading && pdfUrl && (
                    <div className='text-center m-10'>
                        <a href={pdfUrl} target='_blank' rel='noreferrer' className='btn btn-success btn-lg'>
                            Otvori PDF
                        </a>
                    </div>
                )}

            </KTCardBody>
        </KTCard>
    )
}

export default KupciPdfProcessor